import axios, { AxiosInstance } from 'axios';

// Criando uma instância do Axios com configurações padrão
export const api: AxiosInstance = axios.create({
    method: 'post', // Método HTTP padrão
    headers: {
        'Content-Type': 'application/json', // Tipo de conteúdo padrão
    },
});
